import script from "./PersonalInfoForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonalInfoForm.vue?vue&type=script&lang=ts&setup=true"

import "./PersonalInfoForm.vue?vue&type=style&index=0&id=162b236c&lang=css"

const __exports__ = script;

export default __exports__